<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="top-btn-container">
  <button type="button" class="blue-button all-deals-btn"><a [routerLink]="'/' + getCountry() + '/' + getString('cardDealsUrl')">{{getString('showAllDeals')}}</a></button>
</div>

<div class='deal-container'>
  <app-spinner *ngIf='isLoading'></app-spinner>
  <app-card-deal-item *ngIf='deal' [deal]='deal' [showComments]='true' [showMore]="true"
  (onNoAuth)='header.registerClicked()' (onNewComment)='loadDeal()'></app-card-deal-item>
  <div class='not-found' *ngIf='notFound'>{{getString('dealNotFound')}}</div>
  <button type='button' class='blue-button' *ngIf='notFound'><a [routerLink]="'/' + getCountry() + '/' + getString('cardDealsUrl')">{{getString('goToCardDeals')}}</a></button>
</div>

<app-home-footer></app-home-footer>